import {FormProvider, useForm} from 'react-hook-form'
import {QRCode} from 'react-qr-code'
import PropTypes from 'prop-types'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'

import Form from '../../shared/Form'
import OtpInput from '../../shared/OtpInput'

import {isEmpty} from '../../../lib/tools'

import './tfaSetup.scss'

const TfaSetup = props => {
  const methods = useForm()
  const tfaEnrollment = isEmpty(props.tfaEnrollments) ? {} : props.tfaEnrollments[0]

  return (
    <Paper elevation={3} component='div' className='tfa-setup'>
      <Stack>
        <Typography className='instructions' gutterBottom>
          Please scan the QR code below with your Authenicator App.
          Enter the code displayed in the input below.
        </Typography>
        <QRCode
          className='tfa-key gutter-bottom'
          size={100}
          style={{height: 'auto', maxWidth: '100%', width: '200px', marginBottom: '10px'}}
          value={tfaEnrollment.provisioningUri}
          viewBox='0 0 256 256'
        />
      </Stack>
      <Box component='div'>
        <FormProvider {...methods}>
          <Form onSubmit={props.validateOtp}>
            <OtpInput control={methods.control} autoFocus />
            <Button
              disabled={props.loading}
              className='action'
              sx={{color: '#F7F7F7'}}
              type='submit'
              variant='contained'>
              Submit
            </Button>
          </Form>
        </FormProvider>
      </Box>
    </Paper>
  )
}

TfaSetup.propTypes = {
  enableTfa: PropTypes.func,
  loading: PropTypes.bool,
  open: PropTypes.bool,
  tfaConfig: PropTypes.shape({uri: PropTypes.string, backupCode: PropTypes.string}),
  tfaEnrollments: PropTypes.arrayOf(PropTypes.shape({provisioningUri: PropTypes.string})),
  validateOtp: PropTypes.func
}

export default TfaSetup
